import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {Helmet} from "react-helmet-async";

export default function JobApplyPage() {
    const { id } = useParams(); // URL থেকে জব আইডি নেওয়া
    const navigate = useNavigate();

    const [job, setJob] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // ফর্ম ইনপুট স্টেট
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        cover_letter: ''
    });

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';
    const CAREERS_ENDPOINT = process.env.REACT_APP_API_CAREERS || '/api/careers';

    // জব ডিটেইলস ফেচ করা
    useEffect(() => {
        axios.get(`${API_URL}${CAREERS_ENDPOINT}/${id}`)
            .then(res => {
                setJob(res.data.data || res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching job details:", err);
                setLoading(false);
            });
    }, [id, API_URL, CAREERS_ENDPOINT]);

    // ইনপুট হ্যান্ডলার
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // ফর্ম সাবমিট হ্যান্ডলার
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        setSuccessMessage('');
        setErrorMessage('');

        const payload = {
            career_id: id,
            ...formData
        };

        // লারাভেল ব্যাকএন্ডে রিকোয়েস্ট পাঠানো (web.php-এর /career-apply রাউটে কল হবে)
        axios.post(`${API_URL}/career-apply`, payload)
            .then(res => {
                setSubmitting(false);
                setSuccessMessage('Your application has been submitted successfully!');
                setTimeout(() => {
                    navigate('/career');
                }, 3000);
            })
            .catch(err => {
                setSubmitting(false);
                setErrorMessage(err.response?.data?.message || 'Something went wrong. Please try again.');
            });
    };

    if (loading) {
        return <div className="text-center py-5">Loading application form...</div>;
    }

    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Apply Job</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href="https://tarifoverseasltd.com/blogs"/>
            </Helmet>
        <div className="min-vh-100 bg-light d-flex flex-column font-sans text-dark py-4">
            <main className="container flex-grow-1" style={{ maxWidth: '700px' }}>

                {/* Back Button */}
                <button onClick={() => navigate(-1)} className="btn btn-outline-secondary btn-sm mb-3">
                    ← Back to Job Details
                </button>

                <div className="card shadow-sm border-0 p-4 bg-white rounded-3">
                    <h2 className="fw-bold text-primary text-center">Apply for Job</h2> <hr/>
                    {job && (
                        <p className="text-muted mb-4 pb-2 border-bottom">
                            Position: <strong className="text-primary">{job.title}</strong> ({job.country?.name} • {job.category?.name})
                        </p>
                    )}

                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold small text-muted">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter your full name"
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold small text-muted">Email Address</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold small text-muted">Phone / WhatsApp Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="Enter phone number"
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold small text-muted">Current Address</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="Enter your address"
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold small text-muted">Cover Letter / Message</label>
                                <textarea
                                    className="form-control"
                                    name="cover_letter"
                                    rows="5"
                                    value={formData.cover_letter}
                                    onChange={handleChange}
                                    placeholder="Write a short message or note to the employer..."
                                ></textarea>
                            </div>

                            <div className="col-12 mt-4">
                                <button
                                    type="submit"
                                    className="btn btn-warning text-white fw-bold w-100 py-2.5 shadow-sm"
                                    style={{ backgroundColor: '#f59e0b' }}
                                    disabled={submitting}
                                >
                                    {submitting ? 'Submitting Application...' : '🚀 Submit Application'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </div>
        </>
    );
}